import { GAM_GPT_1X1_KEYS, PLATFORMS } from '../../../../core/constants';
import { SPLIT_DOC_PARAMETERS, GLOBAL_COUNTRY } from '../../../../core/constants';

const { SPLIT_CONFIGS, SPLITS, KEY, SPLIT, SCRIPTS, TYPE, VALUE, DEFER, ASYNC } =
	SPLIT_DOC_PARAMETERS;
const { GLOBAL_PLATFORM } = PLATFORMS;
const { GPT_1X1_TAG, ADPUSHUP_GPT_1X1_TAG, INSTREAM_GPT_1X1_TAG } = GAM_GPT_1X1_KEYS;

export const getCustomNetworkCode = (siteId, videoSectionId) => `
<!--  AP instream video tag -->
<div id="${videoSectionId}" style="max-width: 640px; margin: auto" ></div>
<script type="text/javascript" language="javascript">
  (function () {
    try {
      var bundleUrl = 'https://cdn.adpushup.com/${siteId}/apInstreamBundle.js';
      var queryParamsString = window.location.search;
      var sectionId = "${videoSectionId}";
      var adContainer = document.getElementById(sectionId);
      var scr = document.createElement("script");
      scr.type = "text/javascript";
      scr.language = "javascript";
      adContainer.style.visibility = "hidden";
      scr.src = bundleUrl;
      adContainer.appendChild(scr);
    } catch (error) {
      console.log(error.message);
    }
  })();
</script>`;

export const getSplitDocNetworkCode = (siteId, videoSectionId) => `
<!--  AP instream video tag -->
<div id="apSplitSection" style="max-width: 640px; margin: auto" ></div>
<div id="${videoSectionId}" style="max-width: 640px; margin: auto" ></div>
<script type="text/javascript" language="javascript">
  (function () {
    try {
      var bundleUrl = 'https://cdn.adpushup.com/${siteId}/instreamSplit.js';
      var queryParamsString = window.location.search;
      var sectionId = "${videoSectionId}";
      var adContainer = document.getElementById(sectionId);
      var scr = document.createElement("script");
      scr.type = "text/javascript";
      scr.language = "javascript";
      adContainer.style.visibility = "hidden";
      scr.src = bundleUrl;
      adContainer.appendChild(scr);
    } catch (error) {
      console.log(error.message);
    }
  })();
</script>`;

export const getGpt1x1InjectionScript = (siteId) => {
	return `
<div id="gpt-ap-tag_0"></div>

<script>
(function () {
    const splitSectionDiv = document.getElementById('apSplitSection');

    const sectionId = splitSectionDiv.getAttribute('data-tag-id');
    const tagType = splitSectionDiv.getAttribute('data-tag-type') || '${INSTREAM_GPT_1X1_TAG}';

    const isApTag = tagType === '${ADPUSHUP_GPT_1X1_TAG}';

    const gptApTagDiv = document.getElementById('gpt-ap-tag_0');
    const gptWrapperDiv = document.createElement('div');
    gptWrapperDiv.id = sectionId;

    gptApTagDiv.parentNode.replaceChild(gptWrapperDiv, gptApTagDiv);

    if (isApTag) {
        gptWrapperDiv.classList.add('_ap_apex_ad');
    }

    var isIframe = window.self !== window.top;

    if (!isIframe) {
        loadAdScript(sectionId, isApTag);
        return;
    }

    if (window.top && window.top.apPlayer) {
        return;
    }

    var frameElement = window.frameElement;
    frameElement.id = frameElement.id || "framerate-player";

    var apFrame = window.parent.document.getElementById(frameElement.id);

    var div = document.createElement("div");
    div.id = sectionId;

    if (isApTag) {
        div.classList.add("_ap_apex_ad");
    }
    
    div.setAttribute("max-height", "360");

    var finalApElem = apFrame.parentNode;
    finalApElem.appendChild(div);

    loadAdScript(sectionId, isApTag, div);

    apFrame.style.height = "0px";
})();

function loadAdScript(sectionId, isApTag, container) {
    const w = window.top;

    let headScript = document.createElement("script");
    headScript.src = "https://cdn.adpushup.com/${siteId}/" + (isApTag ? "adpushup.js" : "apInstreamBundle.js");
    headScript.type = "text/javascript";
    headScript.language = "javascript";

    let bodyScript;

    if (isApTag) {
        bodyScript = document.createElement("script");
        bodyScript.innerHTML = \`
        var adpushup = window.adpushup = window.adpushup || {};
        adpushup.que = adpushup.que || [];
        adpushup.que.push(function () {
            adpushup.triggerAd("\${sectionId}");
        });
        \`;
    }

    if (container) {
      container.appendChild(headScript);
      if (isApTag && bodyScript) {
        container.appendChild(bodyScript);
      }
    } else {
      var wrapperSectionContainer = document.getElementById(sectionId);
      wrapperSectionContainer.appendChild(headScript);
      if (isApTag && bodyScript) {
         wrapperSectionContainer.appendChild(bodyScript);
      }
    }
}
</script>
`;
};

export const getGPT1x1SplitTag = (siteId, sectionId, tagType) => `
<!--  AP instream video tag -->
<div id="apSplitSection" style="max-width: 640px; margin: auto" data-tag-id="${sectionId}" data-tag-type="${tagType}"></div>
<script type="text/javascript" language="javascript">
  (function () {
    try {
      var bundleUrl = "https://cdn.adpushup.com/${siteId}/instreamSplit.js";
      var sectionId = "apSplitSection";
      var adContainer = document.getElementById(sectionId);
      var scr = document.createElement("script");
      scr.type = "text/javascript";
      scr.language = "javascript";
      scr.src = bundleUrl;
      adContainer.appendChild(scr);
    } catch (error) {
      console.log(error.message);
    }
  })();
</script>
`;

/**
 * @name removeGptTagFromSplitDoc
 * @description Removes the GPT 1x1 tag from the splitDoc
 * @param {Object} doc - splitDoc
 * @returns {Object} updated splitDoc
 */
export const removeGptTagFromSplitDoc = (doc) => {
	const updatedDoc = structuredClone(doc);

	delete updatedDoc[SCRIPTS]?.[GPT_1X1_TAG];

	const splits = updatedDoc?.[SPLIT_CONFIGS]?.[GLOBAL_PLATFORM]?.[GLOBAL_COUNTRY]?.[SPLITS] || [];
	updatedDoc[SPLIT_CONFIGS][GLOBAL_PLATFORM][GLOBAL_COUNTRY][SPLITS] = splits.filter(
		(item) => item[KEY] !== GPT_1X1_TAG
	);

	return updatedDoc;
};

/**
 * @name shouldUpdateGptTag
 * @description Checks if GPT 1x1 tag needs to be added or corrected in splitDoc
 * @param {Object} doc - splitDoc
 * @returns {boolean}
 */
export const shouldUpdateGptTag = (doc) => {
	if (!doc) return false;

	const scriptExists = !!doc?.[SCRIPTS]?.[GPT_1X1_TAG];

	const splits = doc?.[SPLIT_CONFIGS]?.[GLOBAL_PLATFORM]?.[GLOBAL_COUNTRY]?.[SPLITS] || [];

	const gptSplit = splits.find((item) => item?.[KEY] === GPT_1X1_TAG);

	const isSplit100 = gptSplit?.[SPLIT] === 100;

	return !scriptExists || !isSplit100;
};

/**
 * @name addGptTagToSplitDoc
 * @description Adds or updates the GPT 1x1 tag in the splitDoc
 * @param {Object} doc - splitDoc
 * @param {string} script - GPT 1x1 script
 * @returns {Object} updated splitDoc
 */
export const addGptTagToSplitDoc = (doc, script) => {
	const updatedDoc = structuredClone(doc);

	// scripts
	updatedDoc[SCRIPTS] = {
		...(updatedDoc[SCRIPTS] || {}),
		[GPT_1X1_TAG]: {
			[TYPE]: 'HTML',
			[VALUE]: script,
			[DEFER]: false,
			[ASYNC]: false
		}
	};

	// splits
	const splitConfig = updatedDoc?.[SPLIT_CONFIGS]?.[GLOBAL_PLATFORM]?.[GLOBAL_COUNTRY];

	const existingSplits = splitConfig[SPLITS] || [];

	const resetSplits = existingSplits.map((item) => ({
		...item,
		[SPLIT]: 0
	}));

	splitConfig[SPLITS] = [
		...resetSplits,
		{
			[KEY]: GPT_1X1_TAG,
			[SPLIT]: 100
		}
	];

	return updatedDoc;
};
